<template lang="">
	<div>비밀번호변경페이지</div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
